import { useCallback, useState } from 'react';

export default function useToggle (initialState = false) {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(val => {
    setState(oldState => [true, false].includes(val) ? val : !oldState);
  }, [setState]);
  return [state, toggle];
}
